import styled from 'styled-components'

export default styled.p`
  font-size: 1.15rem;
`
